/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Callrail from './callrail-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Callrail {...validProps} />;
}
SvgComponent.iconName = 'callrail';

export const CallrailIcon = svgIconWrapper(SvgComponent);
